import React, { useState } from "react";
import { motion } from "framer-motion";
import toast from "react-hot-toast";
import { useNavigate, Link } from "react-router-dom";
import api from "../utils/base_url";
import { FaEnvelope } from "react-icons/fa";
import "../styles/PasswordReset.css";

const PasswordReset = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return toast.error("Please enter your email.");

    setLoading(true);
    try {
      const normalizedEmail = email.trim().toLowerCase();
      const res = await api.post("forgot-password-customer/", { email: normalizedEmail });

      if (res.data.status === true) {
        toast.success("Password reset link sent to your email!");
        setTimeout(() => navigate("/login"), 2500);
      } else {
        toast.error(res.data.message || "Failed to send reset link.");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pr-wrapper">
      <motion.div
        className="pr-card"
        initial={{ y: 40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.55, ease: [0.4, 0, 0.2, 1] }}
      >
        {/* Icon */}
        <div className="pr-icon-wrap">
          <FaEnvelope />
        </div>

        <p className="pr-title">Forgot Password?</p>
        <p className="pr-subtitle">
          No worries — enter your registered email and we'll send you a reset link right away.
        </p>

        <form onSubmit={handleSubmit} className="pr-form" noValidate>
          {/* Email field */}
          <div className="pr-field">
            <span className="pr-field-icon"><FaEnvelope /></span>
            <input
              className="pr-field-input"
              type="email"
              placeholder=" "
              value={email}
              required
              autoComplete="email"
              onChange={(e) => setEmail(e.target.value)}
            />
            <label className="pr-field-label">Email address</label>
          </div>

          <button type="submit" className="pr-btn" disabled={loading}>
            {loading && <span className="pr-spinner" aria-hidden />}
            {loading ? "Sending…" : "Send reset link"}
          </button>
        </form>

        <hr className="pr-divider" />

        <div className="pr-back">
          <Link to="/login" className="pr-back-link">← Back to Login</Link>
        </div>
      </motion.div>
    </div>
  );
};

export default PasswordReset;